import React, { useState } from "react";
import Beatloader from "../../../Common/Loaders/Beatloader";
import JobClosingOpenShipmentsForClosing from "./JobClosingOpenShipmentsForClosing";
import JobClosingCostRevenueFinalization from "./JobClosingCostRevenueFinalization";

const JobClosing = () => {
  const [activeTab, setActiveTab] = useState("open_shipments_for_closing");
  const [pageLoader, setPageLoader] = useState(false);

  const TabButton = ({ id, label }) => (
    <button
      className={`btn mx-1 px-4 py-2 rounded-pill ${
        activeTab === id
          ? "btn-light shadow-sm border"
          : "btn-outline-light text-muted border"
      }`}
      style={{
        background: activeTab === id ? "#ffffff" : "#f5f5f5",
        borderColor: "#e4e4e4",
      }}
      onClick={() => setActiveTab(id)}
    >
      {label}
    </button>
  );
  return (
    <>
      {pageLoader ? (
        <Beatloader />
      ) : (
        <div className="page-wrapper">
          <div className="content">
            {/* Tabs */}
            <div className="d-flex flex-wrap align-items-center mb-4 gap-2">
              <TabButton
                id="open_shipments_for_closing"
                label="Open Shipments For Closing"
              />
              <TabButton
                id="cost_revenue_finalization"
                label="Cost Revenue Finalization"
              />
            </div>

            <div className="p-4">
              {/* open_shipments_for_closing */}
              {activeTab === "open_shipments_for_closing" && (
                <JobClosingOpenShipmentsForClosing />
              )}

              {/* cost_revenue_finalization */}
              {activeTab === "cost_revenue_finalization" && (
                <JobClosingCostRevenueFinalization />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default JobClosing;
